import * as React from 'react'

import TeksGradeLevel, { GRADE_CONFIGS } from '../../../../containers/teks/TeksGradeLevel'
import AssignmentFlowNavigation from '../../assignment_flow_navigation'
import { getPageTitle } from '../../../../../Shared'

const AssignTeksGradeLevel = ({ match, ...props }) => {
  const grade = match.params.grade
  const config = GRADE_CONFIGS[grade]
  document.title = getPageTitle("Assign", `TEKS Activity Packs | ${config.gradeName}`)

  return (
    <div>
      <AssignmentFlowNavigation courseSlug={grade} />
      <TeksGradeLevel gradeLevel={grade} {...props} />
    </div>
  )
}

export default AssignTeksGradeLevel
